import styled from "styled-components";
import { Input } from "antd";

export const InputWrapper = styled.div`
  width: 100%;
  padding-top: 10px;

  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper-focused {
    box-shadow: 0 0 2px #8b44ff !important;
    border-color: #6610f2 !important;
  }

  .ant-input-affix-wrapper:focus {
    box-shadow: 0 0 2px #8b44ff !important;
    border-color: #6610f2 !important;
    outline: 0;
  }
  .ant-input-prefix {
    margin-right: 8px;
  }
`;

export const StyledInput = styled(Input)`
  color: black !important;
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "44px"};
  box-shadow: ${({ shadow }) => shadow || "#8b44ff"};
  border-color: ${({ border }) => border || "#dfe1e7"};
  border-radius: ${({ borderRadius }) => borderRadius || "8px"};
  margin-bottom: ${({ bottom }) => bottom || ""};
  &:hover {
    border-color: ${({ borderHover }) => borderHover || "#6610f2"};
    box-shadow: ${({ shadowHover }) => shadowHover || "0 0 2px #8b44ff "};
  }
  &:active {
    border-color: ${({ borderActive }) => borderActive || "#6610f2"};
    box-shadow: ${({ shadowActive }) => shadowActive || "0 0 2px #8b44ff "};
  }

  &:focus {
    border-color: ${({ borderFocus }) => borderFocus || "#6610f2"};
    box-shadow: ${({ shadowFocus }) => shadowFocus || "0 0 2px #8b44ff "};
    border-right-width: 1px;
    outline: 0;
  }
`;
